import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import ReactHtmlParser from "react-html-parser";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions";
import Avatar from "@material-ui/core/Avatar";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import { red } from "@material-ui/core/colors";
import { likeImg, dislikeImg } from "../constants/assets";
import { useState } from "react";
import { useEffect } from "react";
import HexHover from "../../../components/HexHover";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
    margin: 10,
    height: 600,
    position: "relative",
  },
  media: {
    height: 0,
    paddingTop: "56.25%", // 16:9
  },
  action: {
    marginTop: 0,
  },
  title: {
    fontSize: 23,
    fontFamily: "Baskervville",
    lineHeight: "1.3",
  },
  paragraph: {
    fontFamily: "Baskervville",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 4,
    display: "-webkit-box",
    overflow: "hidden",
  },
  actions: {
    position: "absolute",
    width: "100%",
    bottom: "5px",
  },
  bottomText: {
    position: "absolute",
    bottom: "40px",
  },
  subTitle: {
    fontSize: 20,
    fontFamily: "Baskervville",
  },
  expand: {
    transform: "rotate(0deg)",
    marginLeft: "auto",
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: "rotate(180deg)",
  },
  avatar: {
    backgroundColor: red[500],
  },
  like: {
    width: 40,
    height: 40,
    backgroundImage: `url(${likeImg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
  dislike: {
    width: 40,
    height: 40,
    backgroundImage: `url(${dislikeImg})`,
    backgroundPosition: "center",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
  },
}));
const LikeComponent = ({ count = 0 }) => {
  const classes = useStyles();
  return (
    <div className={classes.like}>
      <p>{count}</p>
    </div>
  );
};
const DislikeComponent = ({ count = 0 }) => {
  const classes = useStyles();
  return (
    <div className={classes.dislike}>
      <p>{count}</p>
    </div>
  );
};
const CountPan = ({ shares = 0, reads = 0 }) => {
  return (
    <p>
      {ReactHtmlParser(
        `${shares} <b>shares</b>&nbsp;&nbsp;&nbsp;${reads} <b>reads</b>`
      )}
    </p>
  );
};
export default function ArticleCard({
  content,
  brandName,
  onEdit,
  onShare,
  id,
  hex,
  white,
}) {
  const classes = useStyles();
  const [publishForText, setPublishForText] = useState("");
  const HexButton = HexHover("button", hex);

  useEffect(() => {
    if (content.toMembers === undefined || content.toMembers === true) {
      if (content.toReferrals === undefined || content.toReferrals === true) {
        setPublishForText("Published for customers and prospects.");
      } else {
        setPublishForText("Published for customers.");
      }
    } else {
      if (content.toReferrals === undefined || content.toReferrals === true) {
        setPublishForText("Published for prospects.");
      }
    }
  }, [content]);

  return (
    <Card className={classes.root} key={content.id}>
      <CardHeader
        classes={{
          action: classes.action, // class name, e.g. `classes-nesting-root-x`
        }}
        avatar={
          <Avatar
            aria-label="recipe"
            className={classes.avatar}
            style={{
              backgroundColor: hex ? hex : "white",
              color: white ? "white" : "black",
            }}
          >
            {content.username.charAt(0)}
          </Avatar>
        }
        action={
          <button
            className="btn btn-light"
            data-toggle="modal"
            data-target="#edit_article_modal"
            onClick={onEdit}
          >
            Edit
          </button>
        }
        title={content.username}
        subheader={new Date(content.time).toLocaleDateString("en-US", {
          month: "short",
          day: "numeric",
          year: "numeric",
        })}
      />
      <CardContent>
        <Typography color="textPrimary" className={classes.title}>
          {content.title}
        </Typography>
      </CardContent>
      <CardMedia className={classes.media} image={`${content.leadMedia})`} />
      <CardContent>
        <Typography paragraph color="textPrimary" className={classes.paragraph}>
          {content.leadParagraph}
        </Typography>
      </CardContent>
      {/* <CardActions>
        <IconButton aria-label="add to favorites">
          <LikeComponent />
        </IconButton>
        <IconButton aria-label="share">
          <DislikeComponent />
        </IconButton>
        <CountPan shares={content.shares} reads={content.reads} />
      </CardActions> */}
      <CardContent className={classes.bottomText}>
        <Typography>{publishForText}</Typography>
      </CardContent>
      <CardActions className={classes.actions}>
        <Link
          to={{
            pathname: `http://ecosystem.club/${brandName
              .replace(/\s/g, "")
              .toLowerCase()}/articles/${id}`,
          }}
          target="_blank"
          className="w-100"
        >
          <button className="btn btn-light w-100">View</button>
        </Link>
        <HexButton className="btn btn-light w-100" onClick={onShare}>
          Share
        </HexButton>
      </CardActions>
    </Card>
  );
}



// WEBPACK FOOTER //
// ./src/screens/SuperArticles/components/ArticleCard.js